import Q from 'q';

import API from 'js/lib/api';
import user from 'js/lib/user';

import CourseRoles from 'bundles/common/constants/CourseRoles';

const onDemandSpecializationMemberships = API('/api/onDemandSpecializationMemberships.v1', {
  type: 'rest',
});

const onDemandSpecializationMembershipsApi = {
  create(s12nId: string): Q.Promise<Object> {
    const data = {
      s12nId,
      role: CourseRoles.LEARNER,
      userId: user.get().id,
    };

    return Q(
      onDemandSpecializationMemberships.post('', {
        data,
      })
    );
  },

  enrollInOwnedS12n(s12nId: string, courseId: string): Q.Promise<Object> {
    const data = {
      s12nId,
      courseId,
    };

    return Q(
      onDemandSpecializationMemberships.post('?action=enrollInOwnedS12n', {
        data,
      })
    );
  },
};

export default onDemandSpecializationMembershipsApi;

export const { create, enrollInOwnedS12n } = onDemandSpecializationMembershipsApi;
